import {action, observable, computed} from 'mobx';
import { deviceScreencap } from '@/services/Home';
import DeviceStore from '@/stores/device';
import * as R from 'ramda';
import UserStore from '@/stores/user';
import {message} from 'antd';

export type screencapType = '0' | '1' | '2';

export const screencapTypeText = [
  '截图不刷新',
  '间隔20s刷新',
  '间隔30s刷新'
]

class ScreencapStore {
  
  @observable activeKey: screencapType = '0';
  
  @observable interval: number
  
  @computed get name() {
    return screencapTypeText[Number(this.activeKey)]
  }
  
  @action async deviceScreencap () {
  
  
    const ids = DeviceStore.DeviceBaseStore.deviceList.map((r: any) => r.cid);
    
    if (ids.length === 0) return
    
    const [error] = await deviceScreencap({ids: R.join(',',ids) });
    
    await DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId})
  
    setTimeout(async () => {
      await DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId})
    }, 2000)
    
  
    if (error) return;
    
    message.success('正在刷新中...')
    
  }
  
  @action setScreencapKey (key: screencapType) {
    
    this.activeKey = key;
    this.setTimeScreencap();
    
  }
  
  /* 定时截图 */
  @action setTimeScreencap () {
  
  
    this.interval && clearInterval(this.interval);
    
    if (this.activeKey === '0') return
    
    const delay = [0, 20, 30][Number(this.activeKey)]
  
    this.interval = setInterval(this.deviceScreencap,delay * 1000)
    
  }
  
  
}

export default ScreencapStore;
